// Shared role helpers + display maps. Roles: admin, dept_head, manager, employee.
//
// - isAdmin      : full org-wide control.
// - isDeptHead   : per-department administrator (manages own department, views all).
// - isManager    : legacy "manager-like" (admin OR manager) — team affordances.
// - isManagerLike: admin OR manager OR dept_head — anyone who manages people.

export const ROLE_LABELS = {
  admin: 'Admin',
  dept_head: 'Department Head',
  manager: 'Manager',
  employee: 'Employee',
};

export const ROLE_COLOR = {
  admin: 'red',
  dept_head: 'green',
  manager: 'amber',
  employee: 'blue',
};

export const roleLabel = role => ROLE_LABELS[role] || role;

export const isAdmin       = u => u?.role === 'admin';
export const isDeptHead    = u => u?.role === 'dept_head';
export const isManager     = u => ['admin', 'manager'].includes(u?.role);
export const isManagerLike = u => ['admin', 'manager', 'dept_head'].includes(u?.role);

/**
 * Can this user WRITE for the department currently in view?
 * Admins: always. Department Heads: only when the active department is their own
 * home department (matches the backend's home-department write gate; viewing
 * another department, or "All", is read-only). Everyone else: no.
 */
export const canManageDepartment = (u, activeDepartmentId) =>
  isAdmin(u) ||
  (isDeptHead(u) && activeDepartmentId != null && Number(activeDepartmentId) === Number(u?.department_id));
